export default "__VITE_ASSET__BgUemg6m__"